import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import {
  PixelButton,
  PixelFactoryContext,
  PixelFlexBox,
  PixelInput,
} from 'pixel-base'

import {
  validateDarazStore,
  validateShopifyStore,
  validateStore,
} from 'utils/api-routes.util'

import StoreLogos from './StoreLogos'
import { IPixelFactory } from '../../../../../../decl.d'

const ReAuthenticate = (props) => {
  const { showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { currentStore } = props
  const [storeLink, setStoreLink] = useState('')

  useEffect(() => {
    const data = {
      domain: currentStore.url ? currentStore.url : '',
      origin: 'settings',
      protocol: 'https',
      store_name: currentStore.name,
      re_auth: 1,
      store_id: currentStore.id,
      shop: currentStore.url && currentStore.url.replace('.myshopify.com', ''),
    }
    if (currentStore.type === 'woocom') {
      handleValidateStore(data, setStoreLink)
    } else if (currentStore.type === 'shopify') {
      handleValidateShopifyStore(data, setStoreLink)
    } else if (currentStore.type === 'daraz') {
      handleValidateDarazStore(data, setStoreLink)
    }
  }, [])

  const handleSubmit = () => {
    window.open(storeLink, '_blank')
  }

  const handleValidateStore = (data, setStoreLink) => {
    showPageLoader()
    validateStore(data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        setStoreLink(res.response.data.auth_url)
      } else {
        showFailure(
          res.response.error + ' : ' + res.response.field ||
            res.response.errors,
        )
      }
    })
  }

  const handleValidateDarazStore = (data, setStoreLink) => {
    showPageLoader()
    validateDarazStore(data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        setStoreLink(res.response.data.auth_url)
      } else {
        showFailure(
          res.response.error + ' : ' + res.response.field ||
            res.response.errors,
        )
      }
    })
  }

  const handleValidateShopifyStore = (data, setStoreLink) => {
    showPageLoader()
    validateShopifyStore(data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        setStoreLink(res.response.data.auth_url)
      } else {
        showFailure(
          res.response.error + ' : ' + res.response.field ||
            res.response.errors,
        )
      }
    })
  }

  return (
    <form
      style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
      onSubmit={handleSubmit}
    >
      <PixelFlexBox
        justifyContent="flex-start"
        flexWrap="nowrap"
        alignItems="flex-start"
        alignContent="flex-start"
        width="100%"
        gap="10px"
        style={{
          display: 'inline-flex',
          flexDirection: isMobile ? 'column' : 'row',
          flexGrow: '1',
        }}
      >
        <StoreLogos store_type={currentStore.type} />
      </PixelFlexBox>
      <PixelFlexBox
        justifyContent="flex-start"
        flexWrap="nowrap"
        alignItems="flex-start"
        alignContent="flex-start"
        width="100%"
        gap="10px"
        style={{
          display: 'inline-flex',
          flexDirection: isMobile ? 'column' : 'row',
          flexGrow: '1',
        }}
      >
        <PixelInput
          type={'text'}
          name={'Store Name'}
          placeholder={'Store Name'}
          value={currentStore.name}
          disabled
        />
      </PixelFlexBox>
      {currentStore.url && (
        <PixelFlexBox
          justifyContent="flex-start"
          flexWrap="nowrap"
          alignItems="flex-start"
          alignContent="flex-start"
          width="100%"
          gap="10px"
          style={{
            display: 'inline-flex',
            flexDirection: isMobile ? 'column' : 'row',
            flexGrow: '1',
          }}
        >
          <PixelInput
            type={'text'}
            name={'Store URL'}
            placeholder={'Store URL'}
            value={currentStore.url}
            disabled
          />
        </PixelFlexBox>
      )}
      <PixelFlexBox
        justifyContent="flex-end"
        flexWrap="nowrap"
        alignItems="flex-start"
        alignContent="flex-start"
        width="100%"
        gap="10px"
        style={{
          display: 'inline-flex',
          flexDirection: isMobile ? 'column' : 'row',
          flexGrow: '1',
        }}
      >
        <PixelButton disabled={storeLink ? false : true} type={'submit'}>
          Connect
        </PixelButton>
      </PixelFlexBox>
    </form>
  )
}

export default ReAuthenticate
